import { beginningOfToday, addDays, isSameDay } from 'lib/datetime/dateUtils'
import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { without } from 'lib/array/arrayUtils'
import { AnythingCategory, EXP_CATEGORY_LUX_PLUS_ID, EXP_CATEGORY_LUX_PLUS_MEMBER_PRICES_ID } from 'constants/experience'

export function getMatchingFilterFromRange(from?: string, to?: string): Experiences.DateFilter | undefined {
  if (!from || !to) return undefined
  const fromDate = moment(from, ISO_DATE_FORMAT).toDate()
  const toDate = moment(to, ISO_DATE_FORMAT).toDate()
  const today = beginningOfToday()
  const tomorrow = addDays(today, 1)

  if (isSameDay(fromDate, today) && isSameDay(toDate, today)) return 'today'
  if (isSameDay(fromDate, tomorrow) && isSameDay(toDate, tomorrow)) return 'tomorrow'

  const fromMoment = moment(from, ISO_DATE_FORMAT)
  const toMoment = moment(to, ISO_DATE_FORMAT)
  const fromDay = fromMoment.day()
  const toDay = toMoment.day()
  const diffDays = toMoment.diff(fromMoment, 'days')
  if ((fromDay === 5 || fromDay === 6) && (toDay === 6 || toDay === 0) && diffDays >= 1 && diffDays <= 2) return 'this-weekend'

  return undefined
}

/**
 * Remove LuxPlus-specific category codes from a search filter array.
 * LuxPlus categories are handled via the dedicated luxPlusFeatures param,
 * not via categoryValues, to avoid scope leak in search results.
 */
export function excludeLuxPlusCategories(categoryCodes: Array<number>): Array<number> {
  return without(categoryCodes, AnythingCategory.id, EXP_CATEGORY_LUX_PLUS_ID, EXP_CATEGORY_LUX_PLUS_MEMBER_PRICES_ID)
}
